import { DateTime } from 'luxon';

const nine30Timestamp = DateTime.now()
  .setZone('America/New_York')
  .set({
    hour: 9,
    minute: 30,
    seconds: 0,
    milliseconds: 0,
  })
  .toMillis();
const nine29Timestamp = DateTime.now()
  .setZone('America/New_York')
  .set({
    hour: 9,
    minute: 29,
    seconds: 0,
    milliseconds: 0,
  })
  .toMillis();

const fourPmTimeStamp = DateTime.now()
  .setZone('America/New_York')
  .set({
    hour: 16,
    minute: 0,
    seconds: 0,
    milliseconds: 0,
  })
  .toMillis();

export const validateTimeStamp = (dataSource, timeStamp) => {
  if (dataSource !== 'LIVE') return true;
  return nine30Timestamp <= timeStamp && timeStamp < fourPmTimeStamp;
};

export const isBeforeNineThirty = (dataSource, timeStamp) => {
  if (dataSource !== 'LIVE') return [false, null];
  return [timeStamp < nine30Timestamp, nine29Timestamp];
};

export const isBeforeStartTime = (
  dataSource,
  startHour,
  startMinute,
  timeStamp,
  timeUnit
) => {
  if (dataSource !== 'LIVE') return [false, null];
  let startTimeStamp;
  if (timeUnit === 'MINUTES') {
    startTimeStamp = DateTime.now()
      .setZone('America/New_York')
      .set({
        hour: startHour,
        minute: startMinute,
        seconds: 0,
        milliseconds: 0,
      })
      .toMillis();
  } else if (timeUnit === 'DAYS') {
    startTimeStamp = DateTime.now()
      .setZone('America/New_York')
      .set({
        hour: 0,
        minute: 0,
        seconds: 0,
        milliseconds: 0,
      })
      .toMillis();
  } else if (timeUnit === 'WEEKS') {
    startTimeStamp = DateTime.now()
      .setZone('America/New_York')
      .startOf('week')
      .set({
        hour:  0,
        minute: 0,
        seconds: 0,
        milliseconds: 0,
      })
      .toMillis();
  } else if (timeUnit === 'MONTHS') {
    startTimeStamp = DateTime.now()
      .setZone('America/New_York')
      .startOf('month')
      .set({
        hour:  0,
        minute: 0,
        seconds: 0,
        milliseconds: 0,
      })
      .toMillis();
  }
  return [timeStamp < startTimeStamp, startTimeStamp];
};
